import { useCallback, useEffect, useRef, useState } from 'react';
import { listOrders } from '../api/orders.api';
import type { OrderStatus, OrdersPage } from '../types/order.types';

const EMPTY_PAGE: OrdersPage = {
  items: [],
  total_count: 0,
  page: 1,
  page_size: 20,
  total_pages: 0,
};

export function useOrders(page: number, status?: OrderStatus) {
  const [data, setData] = useState<OrdersPage>(EMPTY_PAGE);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const mountedRef = useRef(true);
  const generationRef = useRef(0);

  const refetch = useCallback(() => {
    const generation = ++generationRef.current;
    const current = () => mountedRef.current && generationRef.current === generation;
    setLoading(true);
    setError(null);
    return listOrders(page, 20, status)
      .then((next) => {
        if (current()) setData(next);
      })
      .catch(() => {
        if (current()) setError('خطا در دریافت سفارش‌ها');
      })
      .finally(() => {
        if (current()) setLoading(false);
      });
  }, [page, status]);

  useEffect(() => {
    mountedRef.current = true;
    void refetch();
    return () => { mountedRef.current = false; };
  }, [refetch]);

  return { data, loading, error, refetch };
}
